import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteTenant } from "api/tenants";

import { queryKeys } from "./queryKeys";

export const useDeleteTenant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTenant,
    onSuccess: (data, tenantId) => {
      // Invalidate to trigger refetch for mounted observers (e.g., tenant list page)
      queryClient.invalidateQueries({ queryKey: queryKeys.tenants.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.tenants.lists() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenants.detail(tenantId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenants.organization(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenantReports.lists(),
      });

      // Also remove cached data to prevent stale data in unmounted components
      // (e.g., tenant dropdown in rental application modal)
      queryClient.removeQueries({
        queryKey: queryKeys.tenants.all,
        exact: true,
      });
    },
  });
};
